import { NgModule, APP_INITIALIZER } from '@angular/core';
import { KeycloakInitService } from './shared/services/keycloak/keycloak-init.service';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { HeaderModule } from './layout/header/header.module';
import { FooterModule } from './layout/footer/footer.module';
//import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServicesComponent } from 'src/app/shared/services/services.component';
import { HttpComponent } from 'src/app/shared/services/http/http.component';
import { ModelsComponent } from 'src/app/shared/models/models.component';
import { InterceptorService } from 'src/app/shared/services/interceptor/interceptor.service';
import { UserService } from 'src/app/shared/services/http/user/user.service';
import { AuthService } from 'src/app/shared/services/http/auth/auth.service';
import { UtilService } from 'src/app/shared/services/util/util.service';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';

import { DatePipe } from '@angular/common';
import { ExamsModule } from './exams/exams.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ErrorSnackbarComponent } from './components/error-snackbar/error-snackbar.component';
import { SuccessSnackbarComponent } from './components/success-snackbar/success-snackbar.component';
import { ApiErrorDialogComponent } from './components/api-error-dialog/api-error-dialog.component';
import { WarningSnackbarComponent } from './components/warning-snackbar/warning-snackbar.component';
import { DeleteDiscardDialogComponent } from './components/delete-discard-dialog/delete-discard-dialog.component';
import { ShareModule } from './shared/shared.module';
import { DifferentGradeDialogComponent } from './components/different-grade-dialog/different-grade-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    ServicesComponent,
    HttpComponent,
    ModelsComponent,
    PageNotFoundComponent,
    ErrorSnackbarComponent,
    SuccessSnackbarComponent,
    ApiErrorDialogComponent,
    WarningSnackbarComponent,
    DeleteDiscardDialogComponent,
    DifferentGradeDialogComponent,
  ],
  imports: [
    //   BrowserModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserTransferStateModule,
    AppRoutingModule,
    HeaderModule,
    FooterModule,
    NgxUiLoaderModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DatePipe,
    ExamsModule,
    ShareModule,
  ],
  providers: [
    NgxUiLoaderService,
    AuthService,
    UtilService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (s: KeycloakInitService) => () => s.init(),
      deps: [KeycloakInitService],
      multi: true,
    },
    // I18nModule.setLocale(),
    // I18nModule.setLocaleId()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
